/* ==========================================================================
   Filament365 — collection.js
   Shopify Storefront Filtering + Section Rendering API ile sayfa yenilemeden filtreleme.
   - Filtre / sıralama değişince yalnızca ürün alanı ve filtre paneli güncellenir
   - URL (pushState) güncellenir, geri/ileri tuşları çalışır
   - JavaScript yoksa form normal GET gönderimiyle çalışmaya devam eder
   ========================================================================== */
(function () {
  'use strict';

  var S = window.themeStrings || {};
  var F = window.F365;

  class FacetsController extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.sectionId = this.dataset.sectionId;
      this.controller = null;

      // Sıralama kutusu form dışında olabilir (form="" ile bağlı) — e.target.form kullanılır
      var inFacetsForm = function (el) {
        return !!(el.form && el.form.hasAttribute('data-facets-form'));
      };
      this.addEventListener('change', function (e) {
        if (inFacetsForm(e.target) && !e.target.matches('[data-price-input]')) self.submit();
      });
      this.addEventListener('input', F.debounce(function (e) {
        if (e.target.matches('[data-price-input]')) self.submit();
      }, 600));
      this.addEventListener('submit', function (e) {
        if (e.target.closest('[data-facets-form]')) { e.preventDefault(); self.submit(); }
      });

      // Aktif filtre etiketleri, "temizle" ve boş durum bağlantıları
      this.addEventListener('click', function (e) {
        var link = e.target.closest('a[data-facet-link]');
        if (!link) return;
        e.preventDefault();
        self.load(new URL(link.href).search, true);
      });

      // Filtre çekmecesi (mobil)
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-open-filters]')) self.toggleDrawer(true, e.target.closest('[data-open-filters]'));
        else if (e.target.closest('[data-close-filters]') || e.target.matches('[data-filters-overlay]')) self.toggleDrawer(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.classList.contains('is-drawer-open')) self.toggleDrawer(false);
      });

      window.addEventListener('popstate', function () { self.load(window.location.search, false); });
    }

    toggleDrawer(open, opener) {
      var panel = this.querySelector('[data-facets-panel]');
      if (!panel) return;
      this.classList.toggle('is-drawer-open', open);
      if (open) {
        this._opener = opener;
        F.lockScroll();
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('tabindex', '-1');
        panel.focus({ preventScroll: true });
      } else {
        F.unlockScroll();
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        if (this._opener) this._opener.focus({ preventScroll: true });
      }
      document.querySelectorAll('[data-open-filters]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    }

    submit() {
      var form = this.querySelector('[data-facets-form]');
      var fd = new FormData(form);
      var params = new URLSearchParams();
      fd.forEach(function (value, key) {
        if (value !== '' && value !== null) params.append(key, value);
      });
      params.delete('page');
      this.load('?' + params.toString(), true);
    }

    load(search, push) {
      var self = this;
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      var grid = this.querySelector('[data-grid-region]');
      if (grid) { grid.classList.add('is-loading'); grid.setAttribute('aria-busy', 'true'); }

      var base = window.location.pathname;
      var q = search && search.charAt(0) === '?' ? search.slice(1) : (search || '');
      var url = base + '?section_id=' + encodeURIComponent(this.sectionId) + (q ? '&' + q : '');

      // Açık <details> gruplarını hatırla
      var openGroups = {};
      this.querySelectorAll('[data-facet-group]').forEach(function (d) { openGroups[d.dataset.facetGroup] = d.open; });
      var focusId = document.activeElement && document.activeElement.id;

      fetch(url, { signal: this.controller.signal, credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('facets');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-grid-region]');
          var newPanel = doc.querySelector('[data-facets-panel]');
          var currentPanel = self.querySelector('[data-facets-panel]');

          if (newGrid && grid) grid.replaceWith(newGrid);
          if (newPanel && currentPanel) {
            newPanel.querySelectorAll('[data-facet-group]').forEach(function (d) {
              if (openGroups.hasOwnProperty(d.dataset.facetGroup)) d.open = openGroups[d.dataset.facetGroup];
            });
            currentPanel.innerHTML = newPanel.innerHTML;
          }
          var newBar = doc.querySelector('[data-facets-bar]');
          var curBar = self.querySelector('[data-facets-bar]');
          if (newBar && curBar) curBar.innerHTML = newBar.innerHTML;

          if (push) {
            var newUrl = base + (q ? '?' + q : '');
            history.pushState({}, '', newUrl);
          }
          var region = self.querySelector('[data-grid-region]');
          if (region) F.initReveal(region);
          if (region) {
            var count = region.querySelector('[data-results-count]');
            if (count) F.announce(count.textContent.trim());
          }
          if (focusId) {
            var f = document.getElementById(focusId);
            if (f) f.focus({ preventScroll: true });
          }
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          F.toast(S.filtersError, 'error');
          if (grid) { grid.classList.remove('is-loading'); grid.removeAttribute('aria-busy'); }
        });
    }
  }
  customElements.define('facets-controller', FacetsController);
})();
